<template>
    <div class="kp-no-page">
        <div class="no-page-content">
            <div class="empty_state_logo">
                <svg class="empty_state_svg" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M28 25V3C28 1.375 26.625 0 25 0H3C1.3125 0 0 1.375 0 3V25C0 26.6875 1.3125 28 3 28H25C26.625 28 28 26.6875 28 25ZM3 26C2.4375 26 2 25.5625 2 25V3C2 2.5 2.4375 2 3 2H25C25.5 2 26 2.5 26 3V25C26 25.5625 25.5 26 25 26H3ZM16 8.5V7.5C16 7.25 15.75 7 15.5 7H6.5C6.1875 7 6 7.25 6 7.5V8.5C6 8.8125 6.1875 9 6.5 9H15.5C15.75 9 16 8.8125 16 8.5ZM22 14.5V13.5C22 13.25 21.75 13 21.5 13H6.5C6.1875 13 6 13.25 6 13.5V14.5C6 14.8125 6.1875 15 6.5 15H21.5C21.75 15 22 14.8125 22 14.5ZM12 20.5V19.5C12 19.25 11.75 19 11.5 19H6.5C6.1875 19 6 19.25 6 19.5V20.5C6 20.8125 6.1875 21 6.5 21H11.5C11.75 21 12 20.8125 12 20.5Z" fill="#464B52"/>
                </svg>
            </div>
            <div class="empty_state_text-content">
                <div class="empty_state_title">
                    <span>{{ $t('empty.title') }}</span>
                </div>
                <div class="empty_state_subtitle">
                    <span>{{ $t('empty.subtitle') }}</span>
                </div>
            </div>
            <a v-if="topBarConfig.user.ucode === true" :href="$t('empty.urlExtensions')" class="empty_state_link">{{ $t('empty.link') }}<span class="icon-kp-external"></span></a>
            <a v-else :href="$t('empty.url')" class="empty_state_link">{{ $t('empty.link') }}<span class="icon-kp-external"></span></a>
            <div class="empty-btn">
                <a href="javascript:;" @click="boxAdd()" class="empty_state_button">{{ $t('empty.button') }}</a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  methods: mapActions([
    'boxAdd',
  ]),
  computed: mapGetters({
    topBarConfig: 'topBar/config',
  }),
};
</script>


/** WEBPACK FOOTER **
 ** Empty.vue?3159e605
 **/